// views/Admin/Statistics/AdminStatistics.tsx
import Card from '../../../components/common/Card/Card';
import Table from './components/Table/Table';
import BeaconCharts from './components/Charts/BeaconCharts/BeaconCharts';
import { useAuth } from '../../../contexts/AuthContext';
import styles from './AdminStatistics.module.css';

const AdminStatistics = () => {
  const { user } = useAuth();

  return (
    <div className={styles.adminStatistics}>
      <h1>Statistika</h1>

      <div className={styles.analyticsGrid}>
        <div className={styles.fullWidth}>
          <BeaconCharts />
        </div>
        {user?.admin && (
          <>
            <Card className={`${styles.chartContainer} ${styles.fullWidth}`}>
              <Table tableName="total_amounts" />
            </Card>
            <Card className={`${styles.chartContainer} ${styles.fullWidth}`}>
              <Table tableName="bonus_history" />
            </Card>
            <Card className={`${styles.chartContainer} ${styles.fullWidth}`}>
              <Table tableName="recent_users" />
            </Card>
          </>
        )}

      </div>
    </div>
  );
};

export default AdminStatistics;
